var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLayoutBlocks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 11.3H17.7V2.2C17.7 1.8 17.4 1.5 17 1.5H7.1C6.7 1.5 6.4 1.8 6.4 2.2V11.2H2.2C1.8 11.2 1.5 11.5 1.5 11.9V21.7C1.5 22.1 1.8 22.4 2.2 22.4H21.7C22.1 22.4 22.4 22.1 22.4 21.7V11.9C22.4 11.5 22.1 11.2 21.7 11.2L21.8 11.3ZM6.5 14.9V12.7H7.6V14.9H6.5ZM5.8 16.4H8.4C8.8 16.4 9.1 16.1 9.1 15.7V12.8H11.2V21.1H3V12.8H5.1V15.7C5.1 16.1 5.4 16.4 5.8 16.4ZM11.4 5.1V2.9H12.5V5.1H11.4ZM12.7 12.7H14.8V15.6C14.8 16 15.1 16.3 15.5 16.3H18.1C18.5 16.3 18.8 16 18.8 15.6V12.7H20.9V21H12.6V12.7H12.7ZM16.3 14.9V12.7H17.4V14.9H16.3ZM10.7 6.6H13.3C13.7 6.6 14 6.3 14 5.9V3H16.1V11.3H7.9V3H10V5.9C10 6.3 10.3 6.6 10.7 6.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLayoutBlocks);
export default __webpack_public_path__ + "static/media/ic-layout-blocks.fed7d85a2661e23e1eb414bd0ee3fc34.svg";
export { ForwardRef as ReactComponent };